import medicalImg from '../assets/stethoscope.png';
import dentistImg from '../assets/tooth.png';
import psychologistImg from '../assets/psychologist.png';
import nutricionistaImg from '../assets/nutricionista.png';
import fisioterapiaImg from '../assets/terapia.png';
import educadorFisicoImg from '../assets/pulmoes.png';

const getImageProfession = (profession: string) => {
  let icon;

  switch (profession) {
    case 'Médicos':
      icon = medicalImg;
      break;

    case 'Dentistas':
      icon = dentistImg;
      break;

    case 'Psicólogos':
      icon = psychologistImg;
      break;

    case 'Fisioterapeutas':
      icon = fisioterapiaImg;
      break;

    case 'Preparadores Físicos':
      icon = educadorFisicoImg;
      break;

    case 'Nutricionistas':
      icon = nutricionistaImg;
      break;

    default:
      icon = psychologistImg;
      break;
  }

  return icon;
};

export default getImageProfession;